
const TTS_STREAM_API_URL = "http://10.117.253.234:2988/tts/stream";

/**
 * @param {AudioContext} audioContext 
 * @param {Uint8Array} pcmData 
 * @param {number} startTime 
 * @returns {Promise<void>}
 */
async function decodeAndPlay(audioContext, pcmData, startTime) {
  try {
    const int16Array = new Int16Array(pcmData.buffer, pcmData.byteOffset, pcmData.length / 2);
    const float32Array = new Float32Array(int16Array.length);

    for (let i = 0; i < int16Array.length; i++) {
      float32Array[i] = int16Array[i] / 32768.0;
    }

    const audioBuffer = audioContext.createBuffer(1, float32Array.length, audioContext.sampleRate);
    audioBuffer.getChannelData(0).set(float32Array);

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer;
    source.connect(audioContext.destination);

    return new Promise((resolve) => {
      source.onended = resolve;
      source.start(startTime);
    });
  } catch (error) {
    console.error('Erreur lors du décodage ou de la lecture du morceau audio :', error);
  }
}

/**
 * @param {string} text 
 * @param {string} [language='fr'] 
 */
export const playTextToSpeechRealtime = async (text, language = 'fr') => {
  const response = await fetch(TTS_STREAM_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, language }),
  });

  if (!response.ok) {
    throw new Error(`L'API TTS a échoué avec le statut : ${response.status}`);
  }

  const audioContext = new (window.AudioContext || window.webkitAudioContext)({
    sampleRate: 24000,
  });

  if (audioContext.state === 'suspended') {
    await audioContext.resume();
  }

  let nextStartTime = audioContext.currentTime;
  const reader = response.body.getReader();
  let buffer = new Uint8Array();
  let isFirstChunk = true;

  const HEADER_SIZE = 44;
  const MIN_CHUNK_SIZE = 48000;
  const BYTES_PER_SAMPLE = 2;
  
  const playPromises = [];

  while (true) {
    const { done, value } = await reader.read();

    if (value) {
      const dataToAdd = isFirstChunk ? value.slice(HEADER_SIZE) : value;
      isFirstChunk = false;

      const newBuffer = new Uint8Array(buffer.length + dataToAdd.length);
      newBuffer.set(buffer);
      newBuffer.set(dataToAdd, buffer.length);
      buffer = newBuffer;

      while (buffer.length >= MIN_CHUNK_SIZE) {
        const chunkToPlay = buffer.slice(0, MIN_CHUNK_SIZE);
        buffer = buffer.slice(MIN_CHUNK_SIZE);

        nextStartTime = Math.max(nextStartTime, audioContext.currentTime);

        const playPromise = decodeAndPlay(audioContext, chunkToPlay, nextStartTime);
        playPromises.push(playPromise);

        const duration = chunkToPlay.length / (audioContext.sampleRate * BYTES_PER_SAMPLE);
        nextStartTime += duration;
      }
    }

    if (done) {
      if (buffer.length > 0) {
        nextStartTime = Math.max(nextStartTime, audioContext.currentTime);
        const playPromise = decodeAndPlay(audioContext, buffer, nextStartTime);
        playPromises.push(playPromise);
      }
      break;
    }
  }

  await Promise.all(playPromises);
  await audioContext.close();
};


export const textToSpeechAPI = async (text, language = 'fr') => {
  const response = await fetch(TTS_STREAM_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, language }),
  });

  if (!response.ok) {
    throw new Error(`L'API TTS a échoué avec le statut : ${response.status}`);
  }

  return response.blob();
};
